import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FuseFullscreenModule } from '@fuse/components/fullscreen';
import { FuseLoadingBarModule } from '@fuse/components/loading-bar';
import { FuseNavigationModule } from '@fuse/components/navigation';
import { LanguagesModule } from 'app/layout/common/languages/languages.module';
import { SearchModule } from 'app/layout/common/search/search.module';
;
import { UserModule } from 'app/layout/common/user/user.module';
import { SharedModule } from 'app/shared/shared.module';
import { DenseLayoutComponent } from 'app/layout/layouts/vertical/dense/dense.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@ngneat/transloco';
import { HoverClassDirective } from 'app/shared/directives/hover-class.directive';
import { CommonModule } from '@angular/common';
import { PopupHelpPageComponent } from './popup-help-page/popup-help-page.component';
import { QuickCreateAppBubbleButtonComponent } from 'app/shared/components/quick-create-app-bubble-button/quick-create-app-bubble-button.component';
@NgModule({
    declarations: [
        DenseLayoutComponent, HoverClassDirective, PopupHelpPageComponent
    ],
    imports: [
        HttpClientModule,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatTooltipModule,
        MatIconModule,
        MatMenuModule,
        FuseFullscreenModule,
        FuseLoadingBarModule,
        FuseNavigationModule,
        LanguagesModule,
        SearchModule,

        UserModule,
        SharedModule,
        MatTooltipModule,
        TranslocoModule,
        QuickCreateAppBubbleButtonComponent,
    ],
    exports: [
        DenseLayoutComponent
    ]
})
export class DenseLayoutModule {
}
